var _style, _defs, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundResearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D9D9D9;filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st1{mask:url(#mask0_1030_19662_00000168805577440698903380000006528981262123927473_);}\r\n\t.st2{fill:#0E9384;}\r\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 4,
    y: 5.4,
    width: 17.9,
    height: 16.5
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 5.4,
    width: 17.9,
    height: 16.5,
    id: "mask0_1030_19662_00000168805577440698903380000006528981262123927473_"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11,11.4c-0.8,0-1.5-0.3-2.1-0.9C8.3,9.9,8,9.2,8,8.4c0-0.8,0.3-1.5,0.9-2.1c0.6-0.6,1.3-0.9,2.1-0.9 s1.5,0.3,2.1,0.9C13.7,6.9,14,7.6,14,8.4c0,0.8-0.3,1.5-0.9,2.1C12.5,11.1,11.8,11.4,11,11.4z M11,10.4c0.6,0,1-0.2,1.4-0.6 C12.8,9.4,13,8.9,13,8.4c0-0.6-0.2-1-0.6-1.4C12,6.6,11.6,6.4,11,6.4S10,6.6,9.6,7C9.2,7.4,9,7.8,9,8.4c0,0.5,0.2,1,0.6,1.4 C10,10.2,10.4,10.4,11,10.4z M21.2,21.9l-2.7-2.7c-0.3,0.2-0.7,0.4-1,0.5c-0.3,0.1-0.7,0.2-1,0.2c-1,0-1.8-0.3-2.4-1 c-0.7-0.7-1-1.5-1-2.4c0-1,0.3-1.8,1-2.4c0.7-0.7,1.5-1,2.4-1c1,0,1.8,0.3,2.4,1c0.7,0.7,1,1.5,1,2.4c0,0.3-0.1,0.7-0.2,1 s-0.3,0.7-0.5,1l2.7,2.7L21.2,21.9z M16.5,18.9c0.7,0,1.3-0.2,1.7-0.7c0.5-0.5,0.7-1,0.7-1.7c0-0.7-0.2-1.3-0.7-1.7 c-0.5-0.5-1-0.7-1.7-0.7c-0.7,0-1.3,0.2-1.7,0.7c-0.5,0.5-0.7,1-0.7,1.7c0,0.7,0.2,1.3,0.7,1.7C15.2,18.7,15.8,18.9,16.5,18.9z  M4,18.6V17c0-0.4,0.1-0.8,0.4-1.2c0.2-0.3,0.6-0.6,1-0.8c0.7-0.4,1.7-0.7,2.8-1c1.1-0.3,2.4-0.4,3.7-0.3c-0.1,0.2-0.2,0.3-0.3,0.5 c-0.1,0.2-0.1,0.3-0.2,0.5c-1.2-0.1-2.3,0.1-3.3,0.4c-1,0.3-1.8,0.6-2.3,0.9c-0.3,0.1-0.5,0.3-0.6,0.5C5.1,16.5,5,16.7,5,17v0.6 h6.2c0,0.2,0.1,0.3,0.1,0.5c0.1,0.2,0.1,0.3,0.2,0.5H4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundResearchIcon);
export default __webpack_public_path__ + "static/media/background-research-icon.52e667245a5588a4d10b2f5c28bb6326.svg";
export { ForwardRef as ReactComponent };